import {
  MimaButton,
  MimaText,
  Modal,
  MimaTextArea,
  MimaDropdown,
} from "../../../components";

import { Formik } from "formik";
import React from "react";
import { adminStore } from "../../../stores";

const UpdateParticipants = ({
  closeModal,
  validationSchema,
  loading,
  onSubmit,
}) => {
  const competitionsArray = adminStore.competitions;

 
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitle" align="center" mb={4}>
        Update Participants
      </MimaText>

      <Formik
        initialValues={{
          stage: "",
          competition: "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          handleSubmit,
          setFieldValue,
          handleBlur,
          handleChange,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaDropdown
              labelTitle="Competitions"
              name="competition"
              id="competition"
              value={values.competition}
              placeholder="Select Competition"
              currentValue={values.competition}
              onChange={(data) => {
                setFieldValue("competition", data);
                // setCompetition(data);
              }}
              touched={touched.competition}
              error={errors.competition}
              data={competitionsArray}
              mb={2}
              //   width={30}
            />

            <MimaDropdown
              labelTitle="Competition stage"
              name="stage"
              value={values.stage}
              placeholder="Select Competition stage"
              id="stage"
              currentValue={values.stage}
              onChange={(data) => {
                setFieldValue("stage", data.key);
              }}
              data={[
                { value: "ONE", key: "ONE" },
                { value: "TWO", key: "TWO" },
              ]}
              //   width={30}
              touched={touched.stage}
              error={errors.stage}
            />
            <MimaButton
              title="Submit"
              onClick={handleSubmit}
              type="submit"
              loading={loading}
              mt={2}
              width={38}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default UpdateParticipants;
